import script from "./displayPage.vue?vue&type=script&setup=true&lang=js"
export * from "./displayPage.vue?vue&type=script&setup=true&lang=js"

import "./displayPage.vue?vue&type=style&index=0&id=0ecd7a9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecd7a9e"]])

export default __exports__